var _a, _b;
export const BASE_FONT_SIZE = 15;
export const STATIC_BASE_URL = (_b = (typeof process !== 'undefined' ? (_a = process === null || process === void 0 ? void 0 : process.env) === null || _a === void 0 ? void 0 : _a.PONCHO_STATIC_BASE_URL : undefined)) !== null && _b !== void 0 ? _b : 'https://static.anwb.nl';
